import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'
import { MotionPlugin } from '@vueuse/motion'
import { library } from '@fortawesome/fontawesome-svg-core';
import { faChevronDown, faChevronUp, faArrowRight, faHouse } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

// loadFonts()

import '@themesberg/flowbite';
import './style.css'
import './main.css'

library.add(faChevronDown, faChevronUp, faArrowRight, faHouse)

createApp(App)
  .use(createPinia())
  .use(MotionPlugin)
  .component("font-awesome-icon", FontAwesomeIcon)
  .mount('#SoftanicMegaMenuFrontend') // 